<template>
    <div class="switch" :class="getClass()" @click.stop="changeStatus"><i></i></div>
</template>

<script>
    export default {
        name: 'ui-Switch',
        props: {
            status: {
                // false: apagado; true: encendido
                type: Boolean,
                default: false,
            },
            disabled: {
                // true: desactivado
                type: Boolean,
                default: false,
            },
            standby: {
                // true: en modo de espera, SOLO cuando esta encendido
                type: Boolean,
                default: false,
            },
            noText: {
                // true: no muestra los textos ON/OFF
                type: Boolean,
                default: false,
            },
        },
        methods: {
            getClass: function() {
                var classStyles = '';

                if (this.status) classStyles = 'switch--on';
                else classStyles = 'switch--off';
                if (this.disabled) classStyles = `${classStyles} switch--disabled`;
                if (this.standby) classStyles = `${classStyles} switch--standby`;
                if (this.noText) classStyles = `${classStyles} switch--noText`;

                return classStyles;
            },
            changeStatus: function() {
                if (!this.disabled) this.$emit('update:status', !this.status);
            },
        },
    };
</script>
